import { FetchUsersRequest, FetchUsersResponse, OrgInfo, User } from '../typings';
import { ApiContextType } from '../api-context';

export const fetchUsers = (api: ApiContextType, request: FetchUsersRequest): Promise<FetchUsersResponse> => {
    return api.post(`/users`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};


export const fetchUser = (api: ApiContextType, id: number): Promise<User> => {
    return api.get(`/user/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchOrgInfo = (api: ApiContextType): Promise<OrgInfo> => {
    return api.get(`/info`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updateUser = (api: ApiContextType, id: number, memberType: string, name: string | undefined, biography: string | undefined): Promise<void> => {
    return api.post(`/user/${id}`, { memberType, name, biography })
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};


export const sendInvite = (api: ApiContextType, id: number): Promise<void> => {
    return api.get(`/user/${id}/invite`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};


export const ownUser = (api: ApiContextType, id: number): Promise<void> => {
    return api.post(`/user/${id}/own`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return res.text().then(t => Promise.reject(t));
        });
};

export const addUser = (api: ApiContextType, email: string): Promise<void> => {
    return api.post(`/user/add`, email)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return res.text().then(t => Promise.reject(t));
        });
};

export const createUser = (api: ApiContextType, type: string, email: string): Promise<void> => {
    return api.put(`/user/create`, { email, type, sport: 'LACROSSE' })
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return res.text().then(t => Promise.reject(t));
        });
};

export const unownUser = (api: ApiContextType, id: number): Promise<void> => {
    return api.put(`/user/${id}/unown`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return res.text().then(t => Promise.reject(t));
        });
};

export const removeUser = (api: ApiContextType, id: number): Promise<void> => {
    return api.del(`/user/${id}`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};
